// TODO: Component under development. Commented code will be removed or added as the Sports module refactoring progresses.
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  // ChangeDetectionStrategy,
  Component,
  EventEmitter,
  // ElementRef,
  //   EventEmitter,
  //   HostListener,
  //   Input,
  Output,
  //   Output,
  // Renderer2,
  // inject,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { SportsFormatOddPipe } from "@sports-pipes/sports.format-odd.pipe";
import { SportsGetNameResultPipe } from "@sports-pipes/sports.get-name-result.pipe";
// import { Observable, Subscription } from "rxjs";

@Component({
  selector: "sports-bet-now-button",
  templateUrl: "./sports-bet-now-button.component.html",
  // changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, SportsGetNameResultPipe, SportsFormatOddPipe, TranslateModule],
  styleUrls: ["./sports-bet-now-button.component.scss"],
  host: {
    class: "background-color-button",
  },
})
export class SportsBetNowButtonComponent implements AfterViewInit {
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  ngAfterViewInit(): void {}
  // @HostListener("click")
  onClick() {
    this.clicked.emit();
  }
}
